import { instance } from './index';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { MODAL_QUERY_NM } from './modal';
import { authExpired, getLocalStorage,  } from './auth';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const contextPath = '/setup';
const queryName = 'SETUP';

export const useGetSetupList = () => {
    const queryClient = useQueryClient();
    const authInfo = getLocalStorage();
    return useQuery(
                [`${queryName}_LIST`], 
                () => getSetupList(authInfo ? authInfo.accessToken:''),
                {
                    onError:(err)=> {console.log('useGetSetupList',err);err.response.status===401 && authExpired(queryClient)}
                }
                );
}

const getSetupList = async (accessToken) => {
    const retVal = await instance.get(contextPath,{headers:{Authorization:`Bearer ${accessToken}`}})
                                        .then((res)=>{
                                            return res.data;
                                        })

    return retVal;
}

export const useGetSetupCodeList = () => {
    const queryClient = useQueryClient();
    return useQuery(
                [`${queryName}_CODE_LIST`], 
                () => getSetupCodeList(),
                {
                    onError:(err)=> err.response.status===401 && authExpired(queryClient)
                }
                );
}

const getSetupCodeList = async () => {
    const url = contextPath+'/utils/getSetupCodeList';

    const retVal = await instance.get(url, null)
                                    .then((res)=>{
                                        return res.data;
                                    })

    return retVal;
}